import { render, staticRenderFns } from "./FamilyBackgroundForm.vue?vue&type=template&id=ec10f880&"
import script from "./FamilyBackgroundForm.vue?vue&type=script&lang=js&"
export * from "./FamilyBackgroundForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports